import React, { useState, useEffect } from "react";
import QurealSection from "../common/QurealSection";
import SectionHeader from "../components/commons/SectionHeader";
import {
    Button,
    Table,
    Pagination,
    Space,
    Tooltip,
    Input,
    Segmented,
} from "antd";
import {
    EditOutlined,
    EyeOutlined,
    LockOutlined,
    UnlockOutlined,
    BulbOutlined,
    SettingOutlined,
} from "@ant-design/icons";
import { history } from "../_helpers/history";
import styles from "./styles/PresetManager.module.css";
// import { useItemsFine } from "../_actions/app/items";
import { useItemsFine, useUpdateItemMutation } from "../actions/app/items";
import LoadingBox from "../common/LoadingBox";
import PresetSuggestions from "./PresetSuggestions";
import { startCase } from "lodash";

const per_page = 20;

const FILTERS = {
    All: "",
    Ready: "&filter[enabled]=true",
    Draft: "&filter[enabled]=false",
};

const FILTERS_TYPE = {
    linkedin_post: "&filter[type][_eq]=linkedin_post",
    blog: "&filter[type][_eq]=blog",
};

const TYPE_PLATFORM_MAPPING = {
    linkedin_post: "linkedin",
    blog: "blog",
    tweet: "tweet",
};
function ConceptPresetManager() {
    const [total, setTotal] = useState(1);
    const [page_no, setPageNo] = useState(1);
    const [num_page, setNumPage] = useState(1);
    const [sort, setSort] = useState("date_created");
    const [allRecords, setAllRecords] = useState([]);
    const [paginatedData, setPaginatedData] = useState([]);
    const [searchQuery, setSearchQuery] = useState("");

    const [filters, setFilters] = useState("All");
    const [filter_string, setFilterString] = useState("");
    const [selected_type, setSelectedType] = useState("linkedin_post");
    const [type_filter_string, setTypeFilterString] = useState(
        FILTERS_TYPE["linkedin_post"]
    );

    const { isSuccess, isLoading, data } = useItemsFine(
        "qdb_concept_schema",
        `fields=*&sort=${sort}${`${filter_string}${type_filter_string}${
            searchQuery
                ? `&filter[_or][0][title][_contains]=${searchQuery}&filter[_or][1][generation_prompt][_contains]=${searchQuery}`
                : ""
        }`}&limit=${per_page}&offset=${per_page * (page_no - 1)}&meta=*`,
        true,
        false,
        true,
        true
    );

    const mutation_update = useUpdateItemMutation();

    useEffect(() => {
        if (filters) {
            setFilterString(FILTERS[filters]);
        }
    }, [filters]);

    //   Function to toggle enabled state
    const toggleEnabled = (record) => {
        mutation_update.mutate({
            collection: "qdb_concept_schema",
            id: record.id,

            data: { enabled: !record.enabled },
        });
    };
    const item = { id: 1 };

    useEffect(() => {
        setPageNo(1);
    }, [searchQuery]);

    useEffect(() => {
        if (isSuccess && data) {
            const totalCount = data?.meta?.filter_count;
            console.log("Total records:", totalCount);
            setTotal(totalCount);
            setNumPage(Math.ceil(totalCount / per_page));
            setAllRecords(data?.data);
        }
    }, [isSuccess, data]);

    useEffect(() => {
        if (isSuccess && data) {
            setPaginatedData(data?.data);
        }
    }, [isSuccess, data]);
    return (
        <QurealSection
            header={
                <SectionHeader
                    heading="Concept Preset Manager"
                    icon={<SettingOutlined />}
                >
                    <div
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "10px",
                        }}
                    >
                        <Input.Search
                            placeholder="Search presets by name or block id"
                            allowClear
                            onSearch={(value) => setSearchQuery(value)}
                            style={{ width: 250 }}
                        />
                        <Button
                            onClick={() => {
                                history.push(`/settings/presets/create`, {
                                    from: history.location.pathname,
                                });
                            }}
                        >
                            Create New
                        </Button>
                    </div>
                </SectionHeader>
            }
        >
            <div className={styles.wrapper}>
                <PresetFilters
                    value={filters}
                    onChange={setFilters}
                    selected_type={selected_type}
                    onTypeChange={(new_type) => {
                        setSelectedType(new_type);
                        setTypeFilterString(FILTERS_TYPE[new_type]);
                    }}
                />
                {isLoading && <LoadingBox />}
                {isSuccess && (
                    <Table
                        size="small"
                        locale={{ emptyText: "no preset found" }}
                        columns={[
                            {
                                title: "Title",
                                dataIndex: "title",
                                key: "title",
                                sorter: true,
                            },
                            {
                                title: "Type",
                                dataIndex: "type",
                                key: "type",
                                sorter: true,
                                render: (type) => (
                                    <span>{startCase(type)}</span>
                                ),
                            },
                            {
                                title: "Enabled",
                                dataIndex: "enabled",
                                key: "name",
                                sorter: true,
                                render: (enabled) => (
                                    <span>{enabled ? "🟢" : "🟨"}</span>
                                ),
                            },
                            {
                                title: "Actions",
                                dataIndex: "actions",
                                key: "actions",
                                render: (item, record) => {
                                    return (
                                        <div className={styles.flex_h_center}>
                                            {/* <Button
                                                // type="primary"
                                                onClick={() => {
                                                    history.push(
                                                        `/settings/presets/${record.id}/edit`,
                                                        {
                                                            from: history
                                                                .location
                                                                .pathname,
                                                        }
                                                    );
                                                }}
                                                disabled={record.locked}
                                                icon={<EditOutlined />}
                                            ></Button> */}
                                            <PresetSuggestions
                                                record={record}
                                                trigger={
                                                    <Button
                                                        icon={<BulbOutlined />}
                                                    ></Button>
                                                }
                                                filter_prefix="filter[concept_presets][qdb_concept_schema_id][_eq]"
                                                makePayload={(text) => {
                                                    return {
                                                        label: text,
                                                        text: text.toLowerCase(),
                                                        platforms: [
                                                            TYPE_PLATFORM_MAPPING[
                                                                record?.type
                                                            ],
                                                        ],
                                                        concept_presets: [
                                                            {
                                                                qdb_concept_schema_id:
                                                                    record?.id,
                                                            },
                                                        ],
                                                        value: {
                                                            type: "concept_preset",
                                                            data: {
                                                                preset: record?.title,
                                                                preset_id:
                                                                    record?.id,
                                                            },
                                                        },
                                                    };
                                                }}
                                            />
                                            {/* <Button
                                                icon={<EyeOutlined />}
                                                onClick={() => {
                                                    history.push(
                                                        `/design-admin/templates-manager/${record.id}`,
                                                        {
                                                            from: history
                                                                .location
                                                                .pathname,
                                                        }
                                                    );
                                                }}
                                            ></Button> */}
                                            <Button
                                                // type="primary"
                                                onClick={() =>
                                                    toggleEnabled(record)
                                                }
                                                loading={
                                                    mutation_update.isLoading &&
                                                    mutation_update.variables
                                                        ?.id === record.id
                                                }
                                            >
                                                {record.enabled
                                                    ? "Disable"
                                                    : "Enable"}
                                            </Button>
                                        </div>
                                    );
                                },
                            },
                        ]}
                        rowKey="block_id"
                        bordered={true}
                        dataSource={paginatedData}
                        pagination={false}
                        onChange={(pagination, filter, sorter) => {
                            console.log(sorter);
                            if (sorter?.field && sorter?.order) {
                                setSort(
                                    `${sorter.order === "ascend" ? "-" : ""}${
                                        sorter.field
                                    }`
                                );
                            }
                        }}
                    />
                )}
                <div style={{ height: 20 }}></div>
                {isSuccess && total > per_page && (
                    <Pagination
                        current={page_no}
                        onChange={(new_page_no) => setPageNo(new_page_no)}
                        total={total}
                        pageSize={per_page}
                        showTitle={false}
                        showSizeChanger={false}
                        showQuickJumper={true}
                    />
                )}
            </div>
        </QurealSection>
    );
}

export default ConceptPresetManager;

function PresetFilters({ value, onChange, selected_type, onTypeChange }) {
    return (
        <div
            style={{
                paddingBottom: "15px",
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
            }}
        >
            <Segmented
                options={Object.keys(FILTERS)}
                value={value}
                onChange={(value) => {
                    onChange(value);
                }}
            />

            <Segmented
                options={Object.keys(FILTERS_TYPE)}
                value={selected_type}
                onChange={(value) => {
                    onTypeChange(value);
                }}
            />
        </div>
    );
}
